import { Stripe } from '@stripe/stripe-js';
import PaymentInformation from 'models/PaymentInformation';
import { client } from 'shared';

export function getPaymentInformations(user_id?: number): Promise<PaymentInformation[]> {
    let url = 'api/payment-info/';
    if (user_id) {
        url = `${url}?user_id=${user_id}`;
    }

    return client(url);
}

export function verifyBankAccountMandate(stripeHook: Stripe | null, payMethodId: number, customerId?: string) {
    return client('payment/api/pay-setup/start-setup/', {
        body: { customer_id: customerId, pay_method_id: payMethodId },
    })
        .then((intentResponse) => {
            return stripeHook?.confirmSetup({
                clientSecret: intentResponse.client_secret,
                redirect: 'if_required',
            });
        })
        .then(() => {
            return client(`api/payment-info/${payMethodId}/`, { method: 'PATCH', body: { has_mandate: true } });
        });
}
